// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.agce-futures-risk-modal__text {
  margin-bottom: 22px;
}

.agce-futures-risk-modal__overlay {
  cursor: default;
}

.agce-futures-risk-modal__btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 12px;
  background: #d1aa67;
  color: #111827;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.02em;
  cursor: pointer;
}

/* .agce-futures-risk-modal__btn:hover {
  background: #e5a800;
}

.agce-futures-risk-modal__btn:active {
  background: #d49a00;
} */
`, "",{"version":3,"sources":["webpack://./src/ui/Pages/futures_trade/futuresRiskWarningModal.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;;;;;;GAMG","sourcesContent":[".agce-futures-risk-modal__text {\n  margin-bottom: 22px;\n}\n\n.agce-futures-risk-modal__overlay {\n  cursor: default;\n}\n\n.agce-futures-risk-modal__btn {\n  width: 100%;\n  height: 48px;\n  border: none;\n  border-radius: 12px;\n  background: #d1aa67;\n  color: #111827;\n  font-size: 16px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  cursor: pointer;\n}\n\n/* .agce-futures-risk-modal__btn:hover {\n  background: #e5a800;\n}\n\n.agce-futures-risk-modal__btn:active {\n  background: #d49a00;\n} */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
